import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DocumentoQrComponent } from './components/documento-notarial/documento-qr/documento-qr.component';
import { LegalizacionFirmaQrComponent } from './components/documento-notarial/legalizacion-firma-qr/legalizacion-firma-qr.component';
import { CartaQrComponent } from './components/documento-notarial/carta-qr/carta-qr.component';
import { LibroQrComponent } from './components/documento-notarial/libro-qr/libro-qr.component';
import { PermisoViajeQrComponent } from './components/documento-notarial/permiso-viaje-qr/permiso-viaje-qr.component';
import { ConsultaKardexComponent } from './components/protocolar/consulta-kardex/consulta-kardex.component';
import { HomeComponent } from './page/home/home.component';
import { InformacionKardexComponent } from './components/protocolar/consulta-kardex/informacion-kardex/informacion-kardex.component';
import { RelacionKardexsComponent } from './components/protocolar/consulta-kardex/relacion-kardexs/relacion-kardexs.component';
import { PoderQrComponent } from './components/documento-notarial/poder-qr/poder-qr.component';
import { CertificadoDomiciliarioQrComponent } from './components/documento-notarial/certificado-domiciliario-qr/certificado-domiciliario-qr.component';
import { CertificadoSupervivenciaQrComponent } from './components/documento-notarial/certificado-supervivencia-qr/certificado-supervivencia-qr.component';
import { LibroDeReclamacionesComponent } from './components/libro-de-reclamaciones/libro-de-reclamaciones.component';


const routes: Routes = [{
  path: 'documento/:id',
  component: DocumentoQrComponent
  ////canActivate: [LoginGuard]
},{
  path:'legalizacion-firma/:id',
  component:LegalizacionFirmaQrComponent
},{
  path:'carta-notarial/:id',
  component:CartaQrComponent
},{
  path:'libro-qr/:id',
  component:LibroQrComponent
},{
  path:'permiso-viaje/:id',
  component:PermisoViajeQrComponent
},{
    path:'consulta-kardex',
    component:ConsultaKardexComponent
},{
  path:'informacion-kardex/:id',
  component:InformacionKardexComponent
},{
  path:'relacion-kardex/:documento',
  component:RelacionKardexsComponent
},{
  path:'poder/:id',
  component:PoderQrComponent
},{
  path:'certificado-domiciliario/:id',
  component:CertificadoDomiciliarioQrComponent
},{
  path:'certificado-supervivencia-pcapaz/:id',
  component:CertificadoSupervivenciaQrComponent
},{
  path:'certificado-supervivencia-pincapaz/:id',
  component:CertificadoSupervivenciaQrComponent
},{
  path:'formulario-reclamaciones',
  component:LibroDeReclamacionesComponent
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
